import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { useCrmAccess } from "@/hooks/use-crm-access";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { usePartnerProfile } from "@/hooks/use-partner-profile";
import { PartnerOrdersList } from "@/components/crm/PartnerOrdersList";
import { FixedPageHeader } from "@/components/ui/fixed-page-header";
import { PAGE_HEADERS } from "@/constants/page-headers";

const PartnerOrders = () => {
  const { data: hasCrmAccess, isLoading } = useCrmAccess();
  const { session } = useAuth();
  
  // Get partner profile using the enhanced hook
  const { data: partnerProfile, isLoading: profileLoading } = usePartnerProfile(session?.user?.id);

  if (isLoading || profileLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-slate-600">Loading...</div>
      </div>
    );
  }

  if (!hasCrmAccess || !partnerProfile) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <main className="flex-1">
          <FixedPageHeader {...PAGE_HEADERS.partnerOrders} />
          <div className="p-8 space-y-8" style={{ paddingTop: "8.5rem" }}>
            
            <div className="space-y-6">
              <PartnerOrdersList partnerId={partnerProfile.id} />
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default PartnerOrders;